module.exports = __webpack_public_path__ + "static/media/employeeinout_2.386d02a1.png";